// extracted by mini-css-extract-plugin
module.exports = {"item":"color-item_item__3Pceq","item--active":"color-item_item--active__1faH8","item--disabled":"color-item_item--disabled__1T3hV","icon":"color-item_icon__3q1l4"};